
<template>
  <div>
    <validation-observer ref="customLabelFormValidator">
      <v-form>
        <v-card class="rounded-card" flat>
          <v-card-title>
            カスタム表示ラベル編集
          </v-card-title>
          <v-card-title>
            <h5>
              カスタム表示ラベルは、文言（定型文）を自由に定義でき、電子マニフェストを自社ルールにて詳細に管理する場合に利用します。<br />
              ※マニフェストにデータ登録後、入力設定項目（必須入力、半角英数字、最小・最大入力文字数）は変更できません。
            </h5>
          </v-card-title>

          <v-card-text>
            <v-card flat>
              <v-card-text>

                <!-- タイトル -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.use_title"
                      dense
                      class="mr-3 mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>タイトルの利用有無</small>
                      </template>
                    </v-checkbox>
                  </v-col>

                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="タイトル" :rules="{ required: (custom_label.use_title), max:13 } ">
                      <v-text-field v-model="custom_label.name_title" :error-messages="errors" dense
                                    :disabled="!(custom_label.use_title)"
                                    hide-details="auto" label="タイトル" outlined persistent-placeholder placeholder="" 
                      >
                        <template v-slot:label>
                          <span>タイトル</span>
                          <span class="ml-1">
                            ({{ custom_label.name_title?.length || 0 }} / 13)
                          </span>
                        </template>
                        <template v-slot:counter></template>
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /タイトル -->

                <!-- ラベル１ -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels1_use"
                      dense
                      class="mr-3 mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>ラベル①の利用有無</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="ラベル名①" :rules="{ required: (custom_label.custom_labels1_use), max:13 } ">
                      <v-text-field v-model="custom_label.custom_labels1_name"
                                    :disabled="!(custom_label.custom_labels1_use)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="ラベル名" outlined persistent-placeholder placeholder="" 
                      >
                        <template v-slot:label>
                          <span>ラベル名</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels1_name?.length || 0 }} / 13)
                          </span>
                        </template>
                        <template v-slot:counter></template>                
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-checkbox
                      v-model="custom_label.custom_labels1_required"
                      :disabled="!(custom_label.custom_labels1_use) || !(custom_label.custom_labels1_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>必須入力</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels1_halfsize_alphanumeric"
                      :disabled="!(custom_label.custom_labels1_use) || !(custom_label.custom_labels1_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>半角英数字のみ</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最小入力文字数①" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels1_minimum_characters"
                                    :disabled="!(custom_label.custom_labels1_use) || !(custom_label.custom_labels1_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最小入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最小入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels1_minimum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最大入力文字数①" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels1_maximum_characters"
                                    :disabled="!(custom_label.custom_labels1_use) || !(custom_label.custom_labels1_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最大入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最大入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels1_maximum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>    
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /ラベル１ -->

                <!-- ラベル２ -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels2_use"
                      dense
                      class="mr-3 mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>ラベル②の利用有無</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="ラベル名②" :rules="{ required: (custom_label.custom_labels2_use), max:13 } ">
                      <v-text-field v-model="custom_label.custom_labels2_name"
                                    :disabled="!(custom_label.custom_labels2_use)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="ラベル名" outlined persistent-placeholder placeholder="" 
                      >
                        <template v-slot:label>
                          <span>ラベル名</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels2_name?.length || 0 }} / 13)
                          </span>
                        </template>
                        <template v-slot:counter></template>  
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-checkbox
                      v-model="custom_label.custom_labels2_required"
                      :disabled="!(custom_label.custom_labels2_use) || !(custom_label.custom_labels2_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>必須入力</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels2_halfsize_alphanumeric"
                      :disabled="!(custom_label.custom_labels2_use) || !(custom_label.custom_labels2_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>半角英数字のみ</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最小入力文字数②" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels2_minimum_characters"
                                    :disabled="!(custom_label.custom_labels2_use) || !(custom_label.custom_labels2_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最小入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最小入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels2_minimum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最大入力文字数②" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels2_maximum_characters"
                                    :disabled="!(custom_label.custom_labels2_use) || !(custom_label.custom_labels2_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最大入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最大入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels2_maximum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>    
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /ラベル２ -->

                <!-- ラベル３ -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels3_use"
                      dense
                      class="mr-3 mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>ラベル③の利用有無</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="ラベル名③" :rules="{ required: (custom_label.custom_labels3_use), max:13 } ">
                      <v-text-field v-model="custom_label.custom_labels3_name"
                                    :disabled="!(custom_label.custom_labels3_use)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="ラベル名" outlined persistent-placeholder placeholder="" 
                      >
                        <template v-slot:label>
                          <span>ラベル名</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels3_name?.length || 0 }} / 13)
                          </span>
                        </template>
                        <template v-slot:counter></template>  
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-checkbox
                      v-model="custom_label.custom_labels3_required"
                      :disabled="!(custom_label.custom_labels3_use) || !(custom_label.custom_labels3_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>必須入力</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels3_halfsize_alphanumeric"
                      :disabled="!(custom_label.custom_labels3_use) || !(custom_label.custom_labels3_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>半角英数字のみ</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最小入力文字数③" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels3_minimum_characters"
                                    :disabled="!(custom_label.custom_labels3_use) || !(custom_label.custom_labels3_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最小入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最小入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels3_minimum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最大入力文字数③" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels3_maximum_characters"
                                    :disabled="!(custom_label.custom_labels3_use) || !(custom_label.custom_labels3_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最大入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最大入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels3_maximum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /ラベル３ -->

                <!-- ラベル４ -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels4_use"
                      dense
                      class="mr-3 mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>ラベル④の利用有無</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="ラベル名④" :rules="{ required: (custom_label.custom_labels4_use), max:13 } ">
                      <v-text-field v-model="custom_label.custom_labels4_name"
                                    :disabled="!(custom_label.custom_labels4_use)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="ラベル名" outlined persistent-placeholder placeholder="" 
                      >
                        <template v-slot:label>
                          <span>ラベル名</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels4_name?.length || 0 }} / 13)
                          </span>
                        </template>
                        <template v-slot:counter></template>    
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-checkbox
                      v-model="custom_label.custom_labels4_required"
                      :disabled="!(custom_label.custom_labels4_use) || !(custom_label.custom_labels4_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>必須入力</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels4_halfsize_alphanumeric"
                      :disabled="!(custom_label.custom_labels4_use) || !(custom_label.custom_labels4_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>半角英数字のみ</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最小入力文字数④" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels4_minimum_characters"
                                    :disabled="!(custom_label.custom_labels4_use) || !(custom_label.custom_labels4_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最小入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最小入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels4_minimum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最大入力文字数④" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels4_maximum_characters"
                                    :disabled="!(custom_label.custom_labels4_use) || !(custom_label.custom_labels4_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最大入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最大入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels4_maximum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /ラベル４ -->

                <!-- ラベル５ -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels5_use"
                      dense
                      class="mr-3 mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>ラベル⑤の利用有無</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="ラベル名⑤" :rules="{ required: (custom_label.custom_labels5_use), max:13 } ">
                      <v-text-field v-model="custom_label.custom_labels5_name"
                                    :disabled="!(custom_label.custom_labels5_use)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="ラベル名" outlined persistent-placeholder placeholder="" 
                      >
                        <template v-slot:label>
                          <span>ラベル名</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels5_name?.length || 0 }} / 13)
                          </span>
                        </template>
                        <template v-slot:counter></template>    
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-checkbox
                      v-model="custom_label.custom_labels5_required"
                      :disabled="!(custom_label.custom_labels5_use) || !(custom_label.custom_labels5_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>必須入力</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels5_halfsize_alphanumeric"
                      :disabled="!(custom_label.custom_labels5_use) || !(custom_label.custom_labels5_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>半角英数字のみ</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最小入力文字数⑤" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels5_minimum_characters"
                                    :disabled="!(custom_label.custom_labels5_use) || !(custom_label.custom_labels5_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最小入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最小入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels5_minimum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最大入力文字数⑤" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels5_maximum_characters"
                                    :disabled="!(custom_label.custom_labels5_use) || !(custom_label.custom_labels5_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最大入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最大入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels5_maximum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /ラベル５ -->

                <!-- ラベル６ -->
                <v-row>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels6_use"
                      dense
                      class="mr-3 mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>ラベル⑥の利用有無</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="3">
                    <validation-provider v-slot="{ errors }" name="ラベル名⑥" :rules="{ required: (custom_label.custom_labels6_use), max:13 } ">
                      <v-text-field v-model="custom_label.custom_labels6_name"
                                    :disabled="!(custom_label.custom_labels6_use)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="ラベル名" outlined persistent-placeholder placeholder="" 
                      >
                        <template v-slot:label>
                          <span>ラベル名</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels6_name?.length || 0 }} / 13)
                          </span>
                        </template>
                        <template v-slot:counter></template>    
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="1">
                    <v-checkbox
                      v-model="custom_label.custom_labels6_required"
                      :disabled="!(custom_label.custom_labels6_use) || !(custom_label.custom_labels6_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>必須入力</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <v-checkbox
                      v-model="custom_label.custom_labels6_halfsize_alphanumeric"
                      :disabled="!(custom_label.custom_labels6_use) || !(custom_label.custom_labels6_changeable_flag)"
                      dense
                      class="mt-2"
                      label=""
                      hide-details="auto"
                    >
                      <template v-slot:label>
                        <small>半角英数字のみ</small>
                      </template>
                    </v-checkbox>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最小入力文字数⑥" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels6_minimum_characters"
                                    :disabled="!(custom_label.custom_labels6_use) || !(custom_label.custom_labels6_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最小入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最小入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels6_minimum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                  <v-col cols="12" md="2">
                    <validation-provider v-slot="{ errors }" name="最大入力文字数⑥" rules="numeric|min_value:1|max_value:255">
                      <v-text-field v-model="custom_label.custom_labels6_maximum_characters"
                                    :disabled="!(custom_label.custom_labels6_use) || !(custom_label.custom_labels6_changeable_flag)"
                                    :error-messages="errors" dense
                                    hide-details="auto" label="最大入力文字数" outlined persistent-placeholder placeholder=""
                                    reverse type="number" @keydown.69.prevent 
                      >
                        <template v-slot:label>
                          <span>最大入力文字数</span>
                          <span class="ml-1">
                            ({{ custom_label.custom_labels6_maximum_characters?.length || 0 }} / 3)
                          </span>
                        </template>
                        <template v-slot:counter></template>   
                      </v-text-field>
                    </validation-provider>
                  </v-col>
                </v-row>
                <!-- /ラベル６ -->

              </v-card-text>

            </v-card>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" @click="registerButtonClickEvent">
              登録
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'customLabelFormValidator',
  components: {},
  mixins: [],
  data() {
    return {
      useTypes: null,
      custom_label: {
        name_title: null,
        custom_labels1_name: null,
        custom_labels1_minimum_characters: null,
        custom_labels1_maximum_characters: null,
        custom_labels2_name: null,
        custom_labels2_minimum_characters: null,
        custom_labels2_maximum_characters: null,
        custom_labels3_name: null,
        custom_labels3_minimum_characters: null,
        custom_labels3_maximum_characters: null,
        custom_labels4_name: null,
        custom_labels4_minimum_characters: null,
        custom_labels4_maximum_characters: null,
        custom_labels5_name: null,
        custom_labels5_minimum_characters: null,
        custom_labels5_maximum_characters: null,
        custom_labels6_name: null,
        custom_labels6_minimum_characters: null,
        custom_labels6_maximum_characters: null,
      },
    }
  },
  computed: {
  },
  created() {
    this.editMasterCustomLabel().then((content) => {
      this.custom_label = content
      this.useTypes = content.use_types
    })
  },
  methods: {
    ...mapActions('DriverMasterCustomLabel', {
      editMasterCustomLabel: 'edit',
      updateMasterCustomLabel: 'update'
    }),
    registerButtonClickEvent() {
      let $self = this
      this.$refs.customLabelFormValidator.validate().then((result) => {
        if (result) {
          $self.sendRegistrationInformation()
        }
      })
    },
    sendRegistrationInformation() {
      let params = {
        use_title: this.custom_label.use_title,
        name_title: this.custom_label.name_title,
        custom_labels1_use: this.custom_label.custom_labels1_use,
        custom_labels1_name: this.custom_label.custom_labels1_name,
        custom_labels1_required: this.custom_label.custom_labels1_required,
        custom_labels1_halfsize_alphanumeric: this.custom_label.custom_labels1_halfsize_alphanumeric,
        custom_labels1_minimum_characters: this.custom_label.custom_labels1_minimum_characters,
        custom_labels1_maximum_characters: this.custom_label.custom_labels1_maximum_characters,
        custom_labels2_use: this.custom_label.custom_labels2_use,
        custom_labels2_name: this.custom_label.custom_labels2_name,
        custom_labels2_required: this.custom_label.custom_labels2_required,
        custom_labels2_halfsize_alphanumeric: this.custom_label.custom_labels2_halfsize_alphanumeric,
        custom_labels2_minimum_characters: this.custom_label.custom_labels2_minimum_characters,
        custom_labels2_maximum_characters: this.custom_label.custom_labels2_maximum_characters,
        custom_labels3_use: this.custom_label.custom_labels3_use,
        custom_labels3_name: this.custom_label.custom_labels3_name,
        custom_labels3_required: this.custom_label.custom_labels3_required,
        custom_labels3_halfsize_alphanumeric: this.custom_label.custom_labels3_halfsize_alphanumeric,
        custom_labels3_minimum_characters: this.custom_label.custom_labels3_minimum_characters,
        custom_labels3_maximum_characters: this.custom_label.custom_labels3_maximum_characters,
        custom_labels4_use: this.custom_label.custom_labels4_use,
        custom_labels4_name: this.custom_label.custom_labels4_name,
        custom_labels4_required: this.custom_label.custom_labels4_required,
        custom_labels4_halfsize_alphanumeric: this.custom_label.custom_labels4_halfsize_alphanumeric,
        custom_labels4_minimum_characters: this.custom_label.custom_labels4_minimum_characters,
        custom_labels4_maximum_characters: this.custom_label.custom_labels4_maximum_characters,
        custom_labels5_use: this.custom_label.custom_labels5_use,
        custom_labels5_name: this.custom_label.custom_labels5_name,
        custom_labels5_required: this.custom_label.custom_labels5_required,
        custom_labels5_halfsize_alphanumeric: this.custom_label.custom_labels5_halfsize_alphanumeric,
        custom_labels5_minimum_characters: this.custom_label.custom_labels5_minimum_characters,
        custom_labels5_maximum_characters: this.custom_label.custom_labels5_maximum_characters,
        custom_labels6_use: this.custom_label.custom_labels6_use,
        custom_labels6_name: this.custom_label.custom_labels6_name,
        custom_labels6_required: this.custom_label.custom_labels6_required,
        custom_labels6_halfsize_alphanumeric: this.custom_label.custom_labels6_halfsize_alphanumeric,
        custom_labels6_minimum_characters: this.custom_label.custom_labels6_minimum_characters,
        custom_labels6_maximum_characters: this.custom_label.custom_labels6_maximum_characters,
      }
      this.updateMasterCustomLabel({ params: params }).then(() => {
        this.$router.push({ name: 'DriverMasterCustomLabel' })
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>
